import React from "react";
import { Form, Input, Select } from "antd";
import SHIPPING_FORM, { COUNTRY_OPTIONS } from "../constants";

const { FIELDS, ERRORS } = SHIPPING_FORM;

const countryFilterOption = (
  input: string,
  option?: { label: string; value: string },
) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

const ShippingFields: React.FC = () => (
  <>
    <Form.Item
      name={FIELDS.FULL_NAME.name}
      label={FIELDS.FULL_NAME.label}
      rules={[{ required: true, message: ERRORS.FULL_NAME }]}
    >
      <Input placeholder={FIELDS.FULL_NAME.placeholder} />
    </Form.Item>

    <div className="sf-form-row">
      <Form.Item
        name={FIELDS.PHONE.name}
        label={FIELDS.PHONE.label}
        rules={[{ required: true, message: ERRORS.PHONE }]}
      >
        <Input placeholder={FIELDS.PHONE.placeholder} />
      </Form.Item>
      <Form.Item
        name={FIELDS.EMAIL.name}
        label={FIELDS.EMAIL.label}
        rules={[
          { required: true, message: ERRORS.EMAIL_REQUIRED },
          { type: "email", message: ERRORS.EMAIL_FORMAT },
        ]}
      >
        <Input placeholder={FIELDS.EMAIL.placeholder} />
      </Form.Item>
    </div>

    <Form.Item
      name={FIELDS.ADDRESS_1.name}
      label={FIELDS.ADDRESS_1.label}
      rules={[{ required: true, message: ERRORS.ADDRESS }]}
    >
      <Input placeholder={FIELDS.ADDRESS_1.placeholder} />
    </Form.Item>

    <Form.Item name={FIELDS.ADDRESS_2.name} label={FIELDS.ADDRESS_2.label}>
      <Input placeholder={FIELDS.ADDRESS_2.placeholder} />
    </Form.Item>

    <div className="sf-form-row">
      <Form.Item
        name={FIELDS.CITY.name}
        label={FIELDS.CITY.label}
        rules={[{ required: true, message: ERRORS.CITY }]}
      >
        <Input placeholder={FIELDS.CITY.placeholder} />
      </Form.Item>
      <Form.Item
        name={FIELDS.STATE.name}
        label={FIELDS.STATE.label}
        rules={[{ required: true, message: ERRORS.STATE }]}
      >
        <Input placeholder={FIELDS.STATE.placeholder} />
      </Form.Item>
    </div>

    <div className="sf-form-row">
      <Form.Item
        name={FIELDS.COUNTRY.name}
        label={FIELDS.COUNTRY.label}
        rules={[{ required: true, message: ERRORS.COUNTRY }]}
      >
        <Select
          showSearch
          placeholder={FIELDS.COUNTRY.placeholder}
          options={COUNTRY_OPTIONS}
          optionFilterProp="label"
          filterOption={countryFilterOption}
        />
      </Form.Item>
      <Form.Item
        name={FIELDS.POSTAL.name}
        label={FIELDS.POSTAL.label}
        rules={[{ required: true, message: ERRORS.POSTAL }]}
      >
        <Input placeholder={FIELDS.POSTAL.placeholder} />
      </Form.Item>
    </div>
  </>
);

export default ShippingFields;
